// src/store/auth/reducer.ts
import { AnyAction } from "redux";
import { getUser } from "./storeToken";
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
  RESEND_VERIFY_REQUEST,
  RESEND_VERIFY_SUCCESS,
  RESEND_VERIFY_FAILURE,
  LOGOUT,
} from "./actions";

interface User {
  _id: string;
  email: string;
  isPaid: boolean;
  isVerified: boolean;
  user_avatar?: string;
  tier: string;
}

export interface AuthState {
  user: User | null;
  token: string | null;
  refreshToken: string | null;
  loading: boolean;
  error: string | null;
  registered: boolean;
  emailVerified: boolean;
  verificationSent: boolean;
}

const initialState: AuthState = {
  user: getUser(),
  token: localStorage.getItem("access_token"),
  refreshToken:
    localStorage.getItem("refreshToken") ||
    localStorage.getItem("refresh_token"),
  loading: false,
  error: null,
  registered: false,
  emailVerified: false,
  verificationSent: false,
};

export function authReducer(
  state = initialState,
  action: AnyAction
): AuthState {
  switch (action.type) {
    // LOGIN
    case LOGIN_REQUEST:
      return { ...state, loading: true, error: null };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.user,
        token: action.payload.token,
        refreshToken: action.payload.refreshToken,
        error: null,
      };
    case LOGIN_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // REGISTER
    case REGISTER_REQUEST:
      return { ...state, loading: true, error: null, registered: false };
    case REGISTER_SUCCESS:
      return { ...state, loading: false, registered: true };
    case REGISTER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // VERIFY EMAIL
    case VERIFY_EMAIL_REQUEST:
      return { ...state, loading: true, error: null, emailVerified: false };
    case VERIFY_EMAIL_SUCCESS:
      return { ...state, loading: false, emailVerified: true };
    case VERIFY_EMAIL_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // RESEND VERIFICATION
    case RESEND_VERIFY_REQUEST:
      return { ...state, loading: true, error: null, verificationSent: false };
    case RESEND_VERIFY_SUCCESS:
      return { ...state, loading: false, verificationSent: true };
    case RESEND_VERIFY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // LOGOUT
    case LOGOUT:
      return {
        ...initialState,
        token: null,
        refreshToken: null,
      };

    default:
      return state;
  }
}
